/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ServiceCategory } from '../../models/service-category';

export interface ServiceControllerDelete$Params {
  id: number;
}

export function serviceControllerDelete(http: HttpClient, rootUrl: string, params: ServiceControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategory;
}>> {
  const rb = new RequestBuilder(rootUrl, serviceControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ServiceCategory;
      }>;
    })
  );
}

serviceControllerDelete.PATH = '/service/{id}';
